import type { AdminUserSummary, UserStatus } from '@/versions/v1/shared/admin-seed';

export type UserStatusFilter = UserStatus | null;

export function statusPillTone(
  status: UserStatus,
): 'success' | 'warning' | 'danger' | 'admin' {
  if (status === 'active') return 'success';
  if (status === 'pending') return 'warning';
  if (status === 'rejected') return 'admin';
  return 'danger';
}

export function statusLabel(status: UserStatus): string {
  if (status === 'pending') return 'awaiting';
  if (status === 'rejected') return 'rejected';
  return status;
}

export function filterUsers(
  users: AdminUserSummary[],
  query: string,
  statusFilter: UserStatusFilter,
): AdminUserSummary[] {
  const needle = query.trim().toLowerCase();

  return users.filter((user) => {
    if (statusFilter && user.status !== statusFilter) return false;
    if (!needle) return true;
    const haystack = `${user.email} ${user.name ?? ''}`.toLowerCase();
    return haystack.includes(needle);
  });
}

export function countUsersByStatus(users: AdminUserSummary[]) {
  return {
    total: users.length,
    active: users.filter((user) => user.status === 'active').length,
    pending: users.filter((user) => user.status === 'pending').length,
    blocked: users.filter((user) => user.status === 'blocked').length,
    rejected: users.filter((user) => user.status === 'rejected').length,
  };
}
